(() => {
  const nativeStickySelector = '.f60x__sticky,.zmp__sticky,.dsp__sticky,.ze-mobile-bar,.s65x__sticky,.zs-mobile-bar,.za-mobile-bar,.zd-mobile-bar,.zw-mobile-bar,.zdg__sticky,.f38p__mobile-bar,[data-mobile-bar],.vb-atc-wrap,.sticky-atc,[data-sticky-bar],[data-sticky]';
  function init(node) {
    if (node.dataset.dobeloBundleReady) return;
    const form = document.querySelector('#MainContent form[action*="/cart/add"], #MainContent form[action*="/cart/add.js"]');
    if (!form) return;
    node.dataset.dobeloBundleReady = 'true';
    let quantity = form.querySelector('[name="quantity"]');
    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';
      form.append(quantity);
    }
    const variantInput = form.querySelector('[name="id"]');
    let variants = [];
    try { variants = JSON.parse(node.querySelector('[data-dobelo-bundle-variants]')?.textContent || '[]'); } catch {}
    const buttons = [...node.querySelectorAll('[data-dobelo-bundle-qty]')];
    const onePrice = node.querySelector('[data-dobelo-bundle-one]');
    const twoPrice = node.querySelector('[data-dobelo-bundle-two]');
    const saving = node.querySelector('[data-dobelo-bundle-save]');
    const sticky = node.querySelector('[data-dobelo-bundle-sticky]');
    const stickyPrice = node.querySelector('[data-dobelo-bundle-sticky-price]');
    const stickyAdd = node.querySelector('[data-dobelo-bundle-sticky-add]');
    const addButton = () => form.querySelector('button[name="add"],button[type="submit"],[data-add-button],[data-main-add],[data-dsp-add]');
    function selectedQty() {
      return Number(node.querySelector('[data-dobelo-bundle-qty].is-selected')?.dataset.dobeloBundleQty || 1);
    }
    function setQty(value) {
      const qty = Number(value) === 2 ? 2 : 1;
      buttons.forEach(button => {
        const active = Number(button.dataset.dobeloBundleQty) === qty;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      quantity.value = String(qty);
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }
    function variant() {
      const id = String(variantInput?.value || '');
      return variants.find(item => String(item.id) === id) || variants[0];
    }
    function update() {
      const current = variant();
      if (!current) return;
      if (onePrice) onePrice.textContent = current.one;
      if (twoPrice) twoPrice.textContent = current.two;
      if (saving) {
        const template = saving.dataset.template || saving.textContent;
        if (!saving.dataset.template) saving.dataset.template = template;
        saving.textContent = template.replace(/([0-9]+(?:[.,][0-9]+)?\s*[^\s]+)$/u, current.save);
      }
      if (stickyPrice) stickyPrice.textContent = selectedQty() === 2 ? current.two : current.one;
      if (stickyAdd) stickyAdd.disabled = current.available === false || addButton()?.disabled === true;
    }
    buttons.forEach(button => button.addEventListener('click', () => { setQty(button.dataset.dobeloBundleQty); update(); }));
    form.addEventListener('change', () => setTimeout(update, 0));
    document.addEventListener('change', event => {
      if (form.contains(event.target)) {
        setTimeout(update, 0);
        setTimeout(update, 70);
      }
    });
    quantity.addEventListener('input', () => {
      const value = Number(quantity.value);
      if (value === 1 || value === 2) {
        buttons.forEach(button => {
          const active = Number(button.dataset.dobeloBundleQty) === value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        update();
      }
    });
    if (sticky && !document.querySelector(nativeStickySelector)) sticky.hidden = false;
    stickyAdd?.addEventListener('click', () => {
      const button = addButton();
      if (!button || button.disabled) return;
      button.click();
    });
    const footer = document.querySelector('.db-footer');
    if (sticky && footer && !sticky.hidden && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => sticky.classList.toggle('dobelo-hide-sticky', entries[0].isIntersecting)).observe(footer);
    }
    setQty(1);
    update();
  }
  const start = () => document.querySelectorAll('[data-dobelo-bundle]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();